import type {
  Airport,
  FareDetailsV2,
  TripDetailsV2,
} from "@b2bportal/air-shopping-api";
import { useModuleBEM } from "@b2bportal/core-themes";
import {
  CoreFlightsComponent,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import { Trans, useI18nContext } from "@hopper-b2b/i18n";
import { removeTimezone } from "@hopper-b2b/utilities";
import {
  ItinerarySummary,
  FlightDetails,
  MixedCabinDisclaimer,
  ReviewFare,
} from "@tenant/flights";
import { Dialog, DialogContent, DialogTrigger } from "@tenant/ui";
import dayjs from "dayjs";
import styles from "./styles.module.scss";

export interface ReviewFlightCardComponentProps extends PlatformComponentProps {
  tripDetails: TripDetailsV2;
  sliceIndex: number;
  fareDetails: FareDetailsV2;
  airports: { [key: string]: Airport };
}
export const ReviewFlightCard = ({
  tripDetails,
  sliceIndex,
  fareDetails,
  airports,
}: ReviewFlightCardComponentProps) => {
  const [block, cn] = useModuleBEM(
    styles,
    CoreFlightsComponent.ReviewFlightCard
  );

  const { t, formatDateTime, DateTimeFormatStyle } = useI18nContext();

  const tripSlice = tripDetails.slices[sliceIndex];
  const fareSlice = fareDetails.slices[sliceIndex];

  return (
    <div className={block}>
      <div className={cn("title")}>
        <Trans
          i18nKey={"flightReview.itineraryTitle"}
          values={{
            fromCity: airports?.[tripSlice.originCode]?.cityName,
            toCity: airports?.[tripSlice.destinationCode]?.cityName,
            date: formatDateTime(
              dayjs(removeTimezone(tripSlice.departureTime)).toDate(),
              DateTimeFormatStyle.ShortMonthDayShortWeekday
            ),
          }}
          components={{ 1: <span className={cn("highlight")} /> }}
        />
      </div>

      <div className={cn("card-mobile")}>
        <ItinerarySummary
          tripSlice={tripSlice}
          fareSlice={fareSlice}
          className={cn("summary")}
          hideBorder
        />

        <Dialog>
          <DialogTrigger className={cn("summary-button")}>
            <button className={cn("view-details-button")}>
              {t("viewDetails")}
            </button>
          </DialogTrigger>

          <DialogContent title={t("flightDetails")}>
            <div className={cn("review-fare-container")}>
              <FlightDetails
                flightDetails={tripDetails}
                flightSlice={tripSlice}
                fareSegments={fareSlice.fareDetails.segments}
                planeInfo=""
                isOutgoing={true}
              />
              <MixedCabinDisclaimer fareSlice={fareSlice} />
              <ReviewFare
                tripDetails={tripDetails}
                sliceIndex={sliceIndex}
                fareDetails={fareDetails}
                className={cn("review-fare")}
                airports={airports}
                key={"review-fare_0"}
              />
            </div>
          </DialogContent>
        </Dialog>
      </div>
    </div>
  );
};
